// Must equal SEARCH_PAGE_SIZE in the Rails listings controller (shared cache key).
export const SEARCH_PAGE_SIZE = 24

// Subsequent (infinite-scroll) pages aren't server-rendered, so they stay small.
export const SEARCH_FETCH_MORE_SIZE = 12
